import { Route, Routes } from "react-router";
import Dashboard from "../pages/Dashboard";
import AdminLayout from "../components/AdminLayout";
import Settings from '../pages/Settings';
import TruckList from "../pages/Truck/TruckList";
import AddTruck from "../pages/Truck/AddTruck";
import EditTruck from "../pages/Truck/EditTruck";
import AgentList from "../pages/Agents/AgentList";
import EditAgent from "../pages/Agents/EditAgent";
import AddAgent from "../pages/Agents/AddAgent";
import Categories from "../pages/Category/Categories";
import SubCategories from "../pages/Category/SubCategories";
import TermsAndCondition from "../pages/TermsAndCondition";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import FAQs from "../pages/FAQs";
import CustomerList from "../pages/Customers/CustomerList";
import ViewCustomer from "../pages/Customers/ViewCustomer";
import AddJob from "../pages/Job/AddJob";
import JobList from "../pages/Job/JobList";
import ViewJob from "../pages/Job/ViewJob";
import ServiceList from "../pages/Service/ServiceList";
import AddCode from "../pages/Code/AddCode";
import CodeList from "../pages/Code/CodeList";
import AddTimeSlot from "../pages/TimeSlot/AddTimeSlot";
import TimeSlotList from "../pages/TimeSlot/TimeSlotList";
import ViewTimeSlot from "../pages/TimeSlot/ViewTimeSlot";
import AddSubAdmin from "../pages/SubAdmin/AddSubAdmin";
import AddRole from "../pages/Role/AddRole";
import RoleList from "../pages/Role/RoleList";
import EditRole from "../pages/Role/EditRole";
import PermissionProvider from "../permission/PermissionProvider";
import AddSubService from "../pages/Service/SubServices/AddSubService";
import AllServicesList from "../pages/Service/SubServices/AllServicesList";
import EditCustomer from "../pages/Customers/EditCustomer";
import EditJob from "../pages/Job/EditJob";
import ChatBotCustomers from "../pages/ChatBot/ChatBotCustomers";
import CustomerChat from "../pages/ChatBot/CustomerChat";
import B2BUsersList from "../pages/B2BUsers/B2BUsersList";
import CreateChatQuestion from "../pages/ChatQuestion/CreateChatQuestion";
import ChatQuestionList from "../pages/ChatQuestion/ChatQuestionList";
import EditChatQuestion from "../pages/ChatQuestion/EditChatQuestion";
import EditTimeSlot from "../pages/TimeSlot/EditTimeSlot";
import EditCode from "../pages/Code/EditCode";
import AddInvoice from "../pages/Invoice/AddInvoice";
import PendingInvoices from "../pages/Invoice/PendingInvoices";
import EditInvoice from "../pages/Invoice/EditInvoice";
import AddNotification from "../pages/Notification/AddNotification";
import NotificationList from "../pages/Notification/NotificationList";
import TransactionList from "../pages/Transaction/TransactionList";
import ViewAttendance from "../pages/Agents/ViewAttendance";
import ReviewList from "../pages/Reviews/ReviewList";
import CouponList from "../pages/Coupon/CouponList";
import AddCoupon from "../pages/Coupon/AddCoupon";
import EditCoupon from "../pages/Coupon/EditCoupon";
import AddPromotion from "../pages/Promotion/AddPromotion";
import PromotionList from "../pages/Promotion/PromotionList";
import EditPromotion from "../pages/Promotion/EditPromotion";
import SubAdminList from "../pages/SubAdmin/SubAdminList";
import EditSubAdmin from "../pages/SubAdmin/EditSubAdmin";
import ManageBanner from "../pages/Banners/ManageBanner";

const AdminRouter = () => {
    return (
        <Routes>
            <Route path="*" element={
                <AdminLayout>
                    <Routes>
                        <Route path="*" element={<Dashboard />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        {/* <Route path="/agents" element={<AgentList />} /> */}
                        {/* <Route path="/customers" element={<CustomerList />} /> */}
                        <Route
                            path="/customers"
                            element={
                                <PermissionProvider permissions="view_customer">
                                    <CustomerList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/customer/view/:id"
                            element={
                                <PermissionProvider permissions="view_customer">
                                    <ViewCustomer />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/customer/view/:id" element={<ViewCustomer />} /> */}
                        <Route
                            path="/customers/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_customer">
                                    <EditCustomer />
                                </PermissionProvider>
                            }
                        />
                        <Route path="/customer/edit/:id" element={<EditCustomer />} />
                        {/* <Route path="/agent/add" element={
                            <PermissionProvider permissions="create_agent">
                                <AddAgent />
                            </PermissionProvider>
                        } /> */}
                        <Route
                            path="/agents"
                            element={
                                <PermissionProvider permissions="view_agent">
                                    <AgentList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/agent/add"
                            element={
                                <PermissionProvider permissions="create_agent">
                                    <AddAgent />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/agent/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_agent">
                                    <EditAgent />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/agent/add" element={<AddAgent />} /> */}
                        {/* <Route path="/agent/edit/:id" element={<EditAgent />} /> */}
                        <Route
                            path="/trucks"
                            element={
                                <PermissionProvider permissions="view_truck">
                                    <TruckList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/truck/add"
                            element={
                                <PermissionProvider permissions="create_truck">
                                    <AddTruck />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/truck/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_truck">
                                    <EditTruck />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/trucks" element={<TruckList />} /> */}
                        {/* <Route path="/truck/add" element={<AddTruck />} />
                        <Route path="/truck/edit/:id" element={<EditTruck />} /> */}
                        {/* <Route path="/settings" element={<Settings />} /> */}
                        <Route
                            path="/settings"
                            element={
                                <PermissionProvider permissions="view_setting">
                                    <Settings />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/users" element={<Users />} /> */}
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/categories/:categoryId/sub-categories" element={<SubCategories />} />
                        <Route path="/categories/:categoryId/sub-categories/:subCategoryId/add-service" element={<ServiceList />} />
                        {/* <Route path="/settings" element={<Settings />} /> */}
                        <Route path="/settings/terms-and-condition" element={<TermsAndCondition />} />
                        <Route path="/settings/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/settings/faqs" element={<FAQs />} />
                        <Route
                            path="/job/add"
                            element={
                                <PermissionProvider permissions="create_job">
                                    <AddJob />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/job/view/:id"
                            element={
                                <PermissionProvider permissions="view_job">
                                    <ViewJob />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/job/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_job">
                                    <EditJob />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/jobs"
                            element={
                                <PermissionProvider permissions="view_job">
                                    <JobList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/jobs/:agentId"
                            element={
                                <PermissionProvider permissions="view_job">
                                    <JobList />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/job/add" element={<AddJob />} />
                        <Route path="/job/view/:id" element={<ViewJob />} />
                        <Route path="/job/edit/:id" element={<EditJob />} />
                        <Route path="/jobs" element={<JobList />} />
                        <Route path="/jobs/:agentId" element={<JobList />} /> */}
                        <Route
                            path="/code/add"
                            element={
                                <PermissionProvider permissions="create_code">
                                    <AddCode />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/code/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_code">
                                    <EditCode />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/codes"
                            element={
                                <PermissionProvider permissions="view_code">
                                    <CodeList />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/code/add" element={<AddCode />} />
                        <Route path="/code/edit/:id" element={<EditCode />} />
                        <Route path="/codes" element={<CodeList />} /> */}
                        <Route path="/time_slot/add" element={<AddTimeSlot />} />
                        <Route path="/time_slot" element={<TimeSlotList />} />
                        <Route path="/time_slot/view/:id" element={<ViewTimeSlot />} />
                        <Route path="/time_slot/edit/:id" element={<EditTimeSlot />} />
                        {/* <Route path="/sub_admin" element={<SubAdminList />} />
                        <Route path="/sub_admin/add" element={<AddSubAdmin />} />
                        <Route path="/sub_admin/edit/:id" element={<EditSubAdmin />} /> */}
                        <Route
                            path="/sub_admin"
                            element={
                                <PermissionProvider permissions="view_subadmin">
                                    <SubAdminList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/sub_admin/add"
                            element={
                                <PermissionProvider permissions="create_subadmin">
                                    <AddSubAdmin />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/sub_admin/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_subadmin">
                                    <EditSubAdmin />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/role"
                            element={
                                <PermissionProvider permissions="view_role">
                                    <RoleList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/role/add"
                            element={
                                <PermissionProvider permissions="add_role">
                                    <AddRole />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/role/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_role">
                                    <EditRole />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/b2busers"
                            element={
                                <PermissionProvider permissions="view_customer">
                                    <B2BUsersList />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/role" element={<RoleList />} />
                        <Route path="/role/add" element={<AddRole />} />
                        <Route path="/role/edit/:id" element={<EditRole />} /> */}
                        <Route path="/services" element={<AllServicesList />} />
                        <Route path="/subservices" element={<AddSubService />} />
                        <Route path="/chatbotcustomers" element={<ChatBotCustomers />} />
                        <Route path="/customerchat/:id" element={<CustomerChat />} />
                        {/* <Route path="/b2busers" element={<B2BUsersList />} /> */}
                        <Route path="/chat-question/add" element={<CreateChatQuestion />} />
                        <Route path="/chat-question" element={<ChatQuestionList />} />
                        <Route path="/chat-question/edit/:id" element={<EditChatQuestion />} />
                        <Route path="/invoice" element={<PendingInvoices />} />
                        <Route path="/invoice/add" element={<AddInvoice />} />
                        <Route path="/invoice/edit/:id" element={<EditInvoice />} />
                        <Route
                            path="/notification/add"
                            element={
                                <PermissionProvider permissions="create_notification">
                                    <AddNotification />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/notification"
                            element={
                                <PermissionProvider permissions="view_notification">
                                    <NotificationList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/transaction"
                            element={
                                <PermissionProvider permissions="view_transaction">
                                    <TransactionList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/reviews"
                            element={
                                <PermissionProvider permissions="view_reviews">
                                    <ReviewList />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/notification/add" element={<AddNotification />} />
                        <Route path="/notification" element={<NotificationList />} /> */}
                        {/* <Route path="/transaction" element={<TransactionList />} /> */}
                        {/* <Route path="/reviews" element={<ReviewList />} /> */}
                        <Route path="/view-attendance/:id" element={<ViewAttendance />} />
                        <Route
                            path="/coupon"
                            element={
                                <PermissionProvider permissions="view_coupon">
                                    <CouponList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/coupon/add"
                            element={
                                <PermissionProvider permissions="create_coupon">
                                    <AddCoupon />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/coupon/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_coupon">
                                    <EditCoupon />
                                </PermissionProvider>
                            }
                        />
                        {/* <Route path="/coupon" element={<CouponList />} />
                        <Route path="/coupon/add" element={<AddCoupon />} />
                        <Route path="/coupon/edit/:id" element={<EditCoupon />} /> */}
                        <Route
                            path="/promotion"
                            element={
                                <PermissionProvider permissions="view_promotion">
                                    <PromotionList />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/promotion/add"
                            element={
                                <PermissionProvider permissions="create_promotion">
                                    <AddPromotion />
                                </PermissionProvider>
                            }
                        />
                        <Route
                            path="/promotion/edit/:id"
                            element={
                                <PermissionProvider permissions="edit_promotion">
                                    <EditPromotion />
                                </PermissionProvider>
                            }
                        />
                        <Route path="/banners" element={<ManageBanner />} />
                    </Routes>
                </AdminLayout>
            } />
        </Routes>
    );
}

export default AdminRouter
